
import * as React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from "jquery";
import Swal from 'sweetalert2';
import DropDownCellIntervalosSelos from './myDropDownCellIntervalosSelo';
var ValueNumeroInicial = '';
var ValueNumeroFinal = '';
var intervalosAnteriores;
var entidadeSelected = null;
var ProdSelo = null;
function FindProduto(){
  (async (e) => {
    console.log("NumeroSelo")
    const data = {"IDEntidade": parseInt($('#instal_vinica_auto').val().split("!")[1]),
                  "Serie": $('#id-SerieSelo')[0].outerText,
                  "Intervalo": $('#id-Intervalo')[0].outerText}

    const ProdutoSelo = await services.apiCall.requestApi(
        "/Selos/GetProdutobyIntervalos",
        data,
        "get"
    );
      $(".ProdutoSelos").val(ProdutoSelo.produto)
      ProdSelo = ProdutoSelo.produto;
    console.log(ProdutoSelo);
  })();

}

export const NumericCellNrInicialFinal = props => {
  
    const handleChange = e => {
        if (props.onChange) {
          props.onChange({
            dataIndex: 0,
            dataItem: props.dataItem,
            field: props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.target.value
          });
        }
        console.log("SELOS DE GARANTIA INICAL")
        if(props.field == "Nr_Selo_inicial_selosGarantia"){
          if($("#id-Intervalo span") != undefined){
            var numeroIntervaloInicial = $("#id-Intervalo span")[0].innerHTML.split("-")[0];
            var numeroIntervaloFinal = $("#id-Intervalo span")[0].innerHTML.split("-")[1];
            if(e.target.value.length == 7){
              if(parseInt(numeroIntervaloInicial) <= parseInt(e.target.value)){
                ValueNumeroInicial = e.target.value
              }else{
                Swal.fire({
                  title: 'Error!',
                  text: 'O número inserido tem de estar dentro dos intervalos disponíveis',
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
                ValueNumeroInicial = ''
                $(".NumeroInicial").val("");
                
              }
            }else{
              ValueNumeroInicial = e.target.value
            }
          }
        }
        if(props.field == "Nr_Selo_final_selosGarantia"){
          if($("#id-Intervalo span") != undefined){
            var numeroIntervaloInicial = $("#id-Intervalo span")[0].innerHTML.split("-")[0];
            var numeroIntervaloFinal = $("#id-Intervalo span")[0].innerHTML.split("-")[1];
            if(e.target.value.length == 7){
              
              if(parseInt(numeroIntervaloFinal) >= parseInt(e.target.value)){
                ValueNumeroFinal = e.target.value
                FindProduto();
              }else{
                Swal.fire({
                  title: 'Error!',
                  text: 'O número inserido tem de estar dentro dos intervalos disponíveis',
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
                ValueNumeroFinal = '';
                $(".NumeroFinal").val("");
                
              }
            }else{
              ValueNumeroFinal = e.target.value
            }
          }
        }
      };
      
      const {
        dataItem
      } = props;
      const field = props.field || '';
      if(field == "Nr_Selo_inicial_selosGarantia"){
        if(ValueNumeroInicial == '' && dataItem.Nr_Selo_inicial_selosGarantia == ""){
          var dataValue = '' ;
        }else{
          var dataValue = dataItem[field] === null ? '' : dataItem[field];
        }
       
      }
      if(field == "Nr_Selo_final_selosGarantia" ){
        if(ValueNumeroFinal == '' && dataItem.Nr_Selo_final_selosGarantia == ""){
          var dataValue = '' ;
        }else{
          var dataValue = dataItem[field] === null ? '' : dataItem[field];
        }
      }
      if(field == "NrFinal" ){
        if(ValueNumeroFinal == '' && dataItem.NrFinal == ""){
          var dataValue = '' ;
        }else{
          var dataValue = dataItem[field] === null ? '' : dataItem[field];
        }
      }
      if(field == "NrInicial" ){
        if(ValueNumeroFinal == '' && dataItem.NrFinal == ""){
          var dataValue = '' ;
        }else{
          var dataValue = dataItem[field] === null ? '' : dataItem[field];
        }
      }
      if($(".NumeroInicial").val() != '' && $(".NumeroInicial").val() != null  && $(".NumeroFinal").val() != ''  && $(".NumeroFinal").val() != null){
        if($(".NumeroInicial").val().length == 7 && $(".NumeroFinal").val().length == 7){
          var quantidadeValor = (parseInt(ValueNumeroFinal) - parseInt(ValueNumeroInicial))+1;
          $(".QuantidadeSelos").val(String(quantidadeValor))
          $(".QuantidadeSelos").attr("disabled", true)
          $(".ProdutoSelos").val(ProdSelo)
        }
      
      }else{
        $(".QuantidadeSelos").attr("disabled", false)
      }

      var indexId = dataItem.ProductID;
      if(dataItem.inEdit == true){
        indexId = 0
      }
     
     
      if(field == "Nr_Selo_inicial_selosGarantia"){
        // if(props.dataItem.intervalosDisponiveis_selosGarantia != undefined){
        //   if(props.dataItem.intervalosDisponiveis_selosGarantia.text != intervalosAnteriores){
        //     // intervalosAnteriores = props.dataItem.intervalosDisponiveis_selosGarantia.text
        //     return <td>
        //     {dataItem.inEdit ? <input type="text" id='numberboxcell' maxlength="7" placeholder="0000000" className='NumeroInicial' onChange={handleChange} value={""} /> 
        //       : ("")}
        //       </td>
        //   }else{ 
            return <td>
            {dataItem.inEdit ? <input type="text" id='numberboxcell' maxlength="7" placeholder="0000000" className='NumeroInicial' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
              : (dataValue != null ?  dataValue.toString() : undefined)}
              </td>
         // }
          
        // }else{
        //     return <td>
        //     {dataItem.inEdit ? <input type="text" id='numberboxcell' maxlength="7" placeholder="0000000" className='NumeroInicial' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
        //       : (dataValue != null ?  dataValue.toString() : undefined)}
        //       </td>
        // }
       
      }
      if(field == "Nr_Selo_final_selosGarantia"){
        // if(props.dataItem.intervalosDisponiveis_selosGarantia != undefined){
        //   if(props.dataItem.intervalosDisponiveis_selosGarantia.text != intervalosAnteriores){
        //     intervalosAnteriores = props.dataItem.intervalosDisponiveis_selosGarantia.text
        //     return <td>
        //     {dataItem.inEdit ? <input type="text" id='numberboxcell' maxlength="7" placeholder="0000000" className='NumeroFinal' onChange={handleChange} value={""} /> 
        //       : ("")}
        //       </td>
        //   }else{ 
            return <td>
            {dataItem.inEdit ? <input type="text" id='numberboxcell' maxlength="7" placeholder="0000000" className='NumeroFinal' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
              : (dataValue != null ?  dataValue.toString() : undefined)}
              </td>
         // }
        // }else{
        //     return <td>
        //     {dataItem.inEdit ? <input type="text" id='numberboxcell' maxlength="7" placeholder="0000000" className='NumeroFinal' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
        //       : (dataValue != null ?  dataValue.toString() : undefined)}
        //       </td>
        // }
      }
      if(field == "NrFinal"){
        // if(props.dataItem.intervalosDisponiveis_selosGarantia != undefined){
        //   if(props.dataItem.intervalosDisponiveis_selosGarantia.text != intervalosAnteriores){
        //     intervalosAnteriores = props.dataItem.intervalosDisponiveis_selosGarantia.text
        //     return <td>
        //     {dataItem.inEdit ? <input type="text" id='numberboxcell' maxlength="7" placeholder="0000000" className='NumeroFinal' onChange={handleChange} value={""} /> 
        //       : ("")}
        //       </td>
        //   }else{ 
            return <td>
            {dataItem.inEdit ? <input type="text" id='numberboxcell' maxlength="7" placeholder="0000000" className='NumeroFinal' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
              : (dataValue != null ?  dataValue.toString() : undefined)}
              </td>
         // }
        // }else{
        //     return <td>
        //     {dataItem.inEdit ? <input type="text" id='numberboxcell' maxlength="7" placeholder="0000000" className='NumeroFinal' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
        //       : (dataValue != null ?  dataValue.toString() : undefined)}
        //       </td>
        // }
      }
      if(field == "NrInicial"){
        // if(props.dataItem.intervalosDisponiveis_selosGarantia != undefined){
        //   if(props.dataItem.intervalosDisponiveis_selosGarantia.text != intervalosAnteriores){
        //     intervalosAnteriores = props.dataItem.intervalosDisponiveis_selosGarantia.text
        //     return <td>
        //     {dataItem.inEdit ? <input type="text" id='numberboxcell' maxlength="7" placeholder="0000000" className='NumeroFinal' onChange={handleChange} value={""} /> 
        //       : ("")}
        //       </td>
        //   }else{ 
            return <td>
            {dataItem.inEdit ? <input type="text" id='numberboxcell' maxlength="7" placeholder="0000000" className='NumeroFinal' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
              : (dataValue != null ?  dataValue.toString() : undefined)}
              </td>
         // }
        // }else{
        //     return <td>
        //     {dataItem.inEdit ? <input type="text" id='numberboxcell' maxlength="7" placeholder="0000000" className='NumeroFinal' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
        //       : (dataValue != null ?  dataValue.toString() : undefined)}
        //       </td>
        // }
      }
}